import MuiBtn, { ButtonProps } from '@mui/material/Button';
import React,{ ComponentProps, FC } from 'react';
import clsx from 'clsx';
import styles from './Button.module.scss'
import { TKind } from '../../utils';

interface IButton extends ButtonProps {
  kind?: TKind
}

const Button: FC<IButton> = (props) => {
  const {children, className, style, onClick, kind='red', ...args} = props

  return (
    <MuiBtn 
      variant="contained"
      className={clsx(className, styles[kind], styles.btn )}
      style={style}
      onClick={onClick}
      {...args}
    >
      {children}
    </MuiBtn>
  )
}

export default Button